import styled from 'styled-components';
import { GREY_200, GREY_900 } from '../../../constants';

export const Container = styled.div`
    display: flex;
    gap: 0.5rem;
    align-content: flex-start;
    `;

export const PhoneInfoContainer = styled.div<{ paddingLeft?: string }>`
    display: flex;
    margin-top: 0.25rem;
    flex-direction: column;
    align-items: center;

    ${({ paddingLeft }) => paddingLeft && `
        padding-left: ${paddingLeft};
    `}
`;

export const PhoneLabel = styled.span`
    font-size: 1rem;
    font-weight: 400;
    color: ${GREY_900};
`;

export const PhoneType = styled.span`
    font-size: 0.875rem;
    color: ${GREY_200};
`;
